<template>
  <div>
    <el-row>


      <el-col :span="24" style="display: flex; justify-content: center">
        <el-button style="padding: 12px; display: inline-block; margin: 0 11px" @click="toNavi(-1)"
          type="primary">《《</el-button>
        <el-date-picker v-model="dateVal" type="month" placeholder="选择日期">
        </el-date-picker>
        <el-button style="padding: 12px; display: inline-block; margin: 0 11px" @click="toNavi(1)"
          type="primary">》》</el-button>
      </el-col>
    </el-row>
    <div>
      <el-divider></el-divider>
      <el-row>
        <el-col :span="3"  v-if="listDatas.CntConus" >
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span><el-tag size="mini" type="danger">导入数据</el-tag> </span>
                 {{ listDatas.CntConus }}条
            </div>
            <div v-for="o in listDatas.ConusInMth" :key="o" class="text item">
              <el-tag size="mini" type="danger">{{o.name}}</el-tag>     {{ o.type }} 
            </div>
          </el-card>
        </el-col>

        <el-col v-if="listDatas.RecdsInMth && listDatas.RecdsInMth.length > 0" v-for="(itm, idx2) in listDatas.RecdsInMth" :key="itm" :span="3">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span><el-tag size="mini" :type="idx2%2==0?'primary':'success'"  >{{ itm.CntRecds.name }}</el-tag> </span>
                 {{ itm.CntRecds.type }}次
            </div>
            <div v-for="o in itm.RecdsInMth" :key="o" class="text item">
              <el-tag  size="mini" :type="idx2%2==0?'primary':'success'"  >{{o.name}}</el-tag>     {{ o.type }} 
            </div>
          </el-card>
        </el-col>
      </el-row>



    </div>

  </div>
</template>

<script>

import api from "@/api/consu/consultationrecord/consultationrecord.js";


export default {
  components: {

  },
  data() {
    return {
      listDatas: {},
      dateVal: new Date(),
      usertype: 0
    };
  },
  methods: {



    toNavi(val) {
      let time = 0;
      if (val > 0) {
        time = this.dateVal.getTime() + 1000 * 60 * 60 * 24 * 30;
      } else {
        time = this.dateVal.getTime() - 1000 * 60 * 60 * 24 * 30;
      }

      this.$set(this, "dateVal", new Date(time));
      this.loaddata();

    },

    loaddata() {

      api.cntMthDatas({ mth: this.dateVal.format("yyyy-MM") }, res => {
        console.log(res);
        this.listDatas = res.data
      });


    },


  }, mounted() {

    this.dateVal = new Date();

    let role = this.$caches.roleCode.get()[0];
    role = role.substring(0, 2)
    this.me = this.$caches.user.get();

    if (role == "dy") {
      this.usertype = 0;
    } else if (role == "zx" || role == "qd" || role == "zm") {
      this.usertype = 1;
    } else {
      this.usertype = 2;
    }

    this.loaddata();
  },

};
</script>
<style scoped>
* {
  margin: 0;
  padding: 0;
  list-style: none;
}

.text {
  font-size: 14px;
}

.item {
  margin-bottom: 12px;

}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both
}

 
.box-card {
  width: 150px;
  height: 800px;
}
</style>